import { useSiteContent } from '@/__lib/SiteContentProvider';
import { strings } from '@/i18n/strings';
import { CtaBand } from '@components/__shared/CtaBand/CtaBand';
import { Photo } from '@components/__shared/Photo/Photo';
import { RichText } from '@components/__shared/RichText/RichText';
import { Seo } from '@components/__shared/Seo/Seo';
import styles from './Services.module.scss';

const priceValue = (label: string): number => {
	const parsed = parseFloat(
		label
			.replace(/\s/g, '')
			.replace(',', '.')
			.replace(/[^\d.]/g, '')
	);
	return Number.isNaN(parsed) ? Infinity : parsed;
};

export const Services = () => {
	const { siteMeta, servicesContent } = useSiteContent();
	const { intro, services } = servicesContent;
	const orderedServices = [...services].sort((a, b) => priceValue(a.priceLabel) - priceValue(b.priceLabel));

	return (
		<>
			<Seo
				title={strings.services.seoTitle}
				description={strings.services.seoDescription(siteMeta.businessName, siteMeta.city)}
				path="/treninky"
			/>

			<section className={styles.intro}>
				<div className={styles.introText}>
					<p className={styles.eyebrow}>{strings.services.introEyebrow}</p>
					<h1>{intro.headline}</h1>
					<RichText className={styles.introBody} html={intro.body} />
				</div>
				<Photo src="/images/trainer-coaching.jpg" className={styles.introPhoto} />
			</section>

			<section className={styles.list}>
				<div className={styles.listHead}>
					<p className={styles.listEyebrow}>{strings.services.listEyebrow}</p>
					<h2>{strings.services.listHeading}</h2>
				</div>
				<div className={styles.rows}>
					{orderedServices.map((service, index) => (
						<article key={index} className={styles.row}>
							<div className={styles.rowMain}>
								<h3>{service.name}</h3>
								<p className={styles.duration}>{strings.services.minutes(service.durationMinutes)}</p>
								<RichText className={styles.description} html={service.description} />
							</div>
							<p className={styles.price}>{service.priceLabel}</p>
						</article>
					))}
				</div>
			</section>

			<CtaBand />
		</>
	);
};
